module.exports = __webpack_public_path__ + "img/star.bb76961f.svg";